import { ISetting } from './../../../../_models/cms/ISetting';
import { SettingService } from './../../../../shared/services/setting.service';
import { ITransferRequest } from './../../../../_models/transfer-sections/ITransferRequest';
import { TransferRequestService } from './../../../../shared/services/transfer-request.service';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './../../../../shared/services/profile.service';
import { IProfile } from './../../../../_models/account/IProfile';
import { ServiceBookService } from '../../../../shared/services/service-book.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service-book-list',
  templateUrl: './service-book-list.component.html'
})
export class ServiceBookListComponent implements OnInit {
  skeleton: boolean = true;
  profile: IProfile;

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: true },
    { title: 'School/Places', key: 'SchoolId', isSortable: true },
    { title: 'Designation', key: 'DesignationId', isSortable: true },
    { title: 'From', key: 'DurationFrom', isSortable: true },
    { title: 'To', key: 'DurationTo', isSortable: true },
    { title: 'Posting Reason', key: 'TransferReason', isSortable: true },
    // { title: 'Transfer Category', key: 'Transfer Category', isSortable: true },
    { title: 'Deductible Leave/Absence(days)', key: 'TransferReason', isSortable: true },
    {}
  ];

  setting: ISetting;
  constructor(private router: Router,
    private toastrService: ToastrService,
    private profileService: ProfileService,
    private transferRequestService: TransferRequestService,
    private settingService: SettingService) {
  }

  async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    if (this.setting && !this.setting.isProfile) {
      this.toastrService.warning("profile module closed!");
      this.router.navigate(['/employee']);
      return;
    }
    else {
      this.getProfile();
    }
  }

  getProfile() {
    this.profileService.logged().subscribe((response: IProfile) => {
      if (response) {
        this.profile = response;
        // if(this.profile.serviceBooks != null){    
        //   this.profileService.updateServiceBookLog().subscribe(
        //     response => {
        //       console.log('Service book log updated successfully:', response);
        //     },
        //     error => {
        //       console.error('Error updating service book log:', error);
        //     }
        //   );
        // }
        // console.log(this.profile)
        this.getTransferRequest();
      }      
      else {
        this.toastrService.success('you must fill up profile first.');
        this.router.navigate(['/employee/profile']);
      }
    });
  }

  getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }


}
